import { useQuery } from '@tanstack/react-query'
import { useEffect, useMemo } from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { teamsGetAll } from '../../api/index.js'
import { Button } from '../../common/Button.tsx'
import { FormCompactSelect } from '../../common/form/formcompactselect.jsx'
import { EyeIconSmall, MiniFilterIcon } from '../../common/icons.jsx'
import { statusOptions, supervisorOptions } from './utils.jsx'

export const TeamCalendarFilters = ({ resetPersonsList, submitForm, currentUser }) => {
	const { t } = useTranslation()
	const form = useFormContext()

	const { data: teams } = useQuery({ queryKey: ['teams'], queryFn: teamsGetAll })

	const currentUserSupervisors = supervisorOptions(currentUser)

	const teamsList = useMemo(() => {
		const teamsData = teams?.data || []
		const currentUserNr = currentUser?.nr
		if (!currentUserNr) return []

		const unique = new Map()
		for (const team of teamsData) {
			const members = team?.teamMembers || []
			const isMember = members.some((m) => m?.nr === currentUserNr)
			if (isMember && team?.teamName && !unique.has(team.teamName)) {
				unique.set(team.teamName, { label: team.teamName, value: team.teamName, members: team.teamMembers })
			}
		}
		return Array.from(unique.values())
	}, [teams, currentUser])

	/** Reset all form filters and persons list to allowed persons */
	const resetFilters = () => {
		form.reset()
		resetPersonsList()
	}

	// Watch form changes and submit to apply filters
	useEffect(() => {
		const subscription = form.watch(form.handleSubmit(submitForm))
		return () => subscription.unsubscribe()
	}, [submitForm, form])

	return (
		<div className="d-flex justify-content-between">
			<div className="d-flex gap-2">
				<FormCompactSelect
					name="team"
					options={teamsList}
					label={t('Team', 'Tiimi')}
					placeholder={t('FilterByTeam', 'Suodata tiimillä')}
					icon={<MiniFilterIcon />}
				/>
				<FormCompactSelect
					name="supervisor"
					label={t('Supervisor')}
					selectProps={{ placeholder: t('All') }}
					options={currentUserSupervisors || []}
					Icon={EyeIconSmall}
				/>
				<FormCompactSelect
					name="status"
					label={t('Status')}
					selectProps={{ placeholder: t('All') }}
					options={statusOptions(t)}
					Icon={EyeIconSmall}
				/>
			</div>
			<Button variant="outline-secondary" className="d-flex align-items-center fw-bold" onClick={resetFilters}>
				<MiniFilterIcon />
				{t('ClearFilters', 'Tyhjennä suodattimet')}
			</Button>
		</div>
	)
}
